import { useSyncExternalStore, type ReactNode } from 'react';

/** Nothing ever changes, so the store never notifies. */
const noSubscribe = () => () => {};
const onClient = () => true;
const onServer = () => false;

/**
 * Renders `placeholder` on the server and on the hydrating pass, then the real
 * children. Keeps canvas/animation components out of the prerendered HTML so
 * hydration never sees markup it cannot reproduce.
 *
 * useSyncExternalStore rather than useState + useEffect: React reads the server
 * snapshot for the hydrating render and the client one immediately after, which
 * is the same two-pass behaviour without a setState inside an effect (and the
 * cascading render the lint rule rightly objects to).
 */
export function ClientOnly({ children, placeholder = null }: { children: ReactNode; placeholder?: ReactNode }) {
  const mounted = useSyncExternalStore(noSubscribe, onClient, onServer);
  return <>{mounted ? children : placeholder}</>;
}
